import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { ActionButton } from '../ActionButton';
import { Modal } from '../Modal';
import { ADALONG_COLORS } from '../../styles';

interface HashtagDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onDeleteCrawlingOnly: () => void;
  onDeleteBoth: () => void;
}

function HashtagDeleteDialog(props: HashtagDeleteDialogProps) {
  return (
    <Modal onClose={props.onClose}>
      <Dialog
        open={props.open}
        onClose={props.onClose}
        maxWidth="sm"
        fullWidth
        onClick={(e) => e.stopPropagation()}
        aria-labelledby="hashtag-delete-dialog-title"
        aria-describedby="hashtag-delete-dialog-description"
        PaperProps={{
          sx: {
            bgcolor: ADALONG_COLORS.DARK_BLACK,
            color: ADALONG_COLORS.LIGHT_WHITE,
            borderRadius: '20px',
            border: `1px solid ${ADALONG_COLORS.LIGHT_BLACK}`,
            backgroundImage: 'none',
          },
        }}
      >
        <DialogTitle 
          id="hashtag-delete-dialog-title"
          sx={{ 
            color: ADALONG_COLORS.LIGHT_WHITE, 
            fontSize: '1.5rem', 
            fontWeight: 'bold', 
            pt: 3, 
            px: 4, 
            mb: 0 
          }}
        >
          Delete Hashtag
        </DialogTitle>
        <DialogContent sx={{ pt: '10px !important', pb: 3, px: 4 }}>
          <DialogContentText 
            id="hashtag-delete-dialog-description"
            sx={{ color: ADALONG_COLORS.LIGHT_WHITE }}
          >
            You are about to delete this hashtag. What would you like to delete?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 4, pb: 4, display: 'flex', justifyContent: 'space-between' }}>
          <ActionButton variant="gray" onAction={props.onClose}>
            CANCEL
          </ActionButton>
          <div style={{ display: 'flex', gap: '8px' }}>
            <ActionButton variant="transparent" onAction={props.onDeleteCrawlingOnly}>
              DELETE CRAWLING ONLY
            </ActionButton>
            <ActionButton variant="red" onAction={props.onDeleteBoth}>
              DELETE BOTH
            </ActionButton>
          </div>
        </DialogActions>
      </Dialog>
    </Modal>
  );
}

export default HashtagDeleteDialog;
